import Lists from './RocketsLists';

const Rockets = () => (
  <>
    <Lists />
  </>
);

export default Rockets;
